import { Component } from "@angular/core";
import {
  NgbCarouselConfig,
  NgbCarouselModule,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-home-secondary-slider",
    imports: [NgbCarouselModule],
    templateUrl: "./home-slider-secondary.component.html",
    styleUrl: "./home-slider-secondary.component.scss"
})
export class HomeSliderSecondaryComponent {
  images: string[] = [
    "./../../../../assets/images/home/home_banner_1.jpg",
    "./../../../../assets/images/home/banner_home_2.jpg",
    "./../../../../assets/images/home/banner_home_3.jpg",
  ];

  constructor(config: NgbCarouselConfig) {
    config.interval = 4000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;
    config.showNavigationIndicators = false;
    config.showNavigationArrows = true;
  }
}
